import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API_PATH } from '../utils/constants/api.constants';
import { BehaviorSubject, filter, Observable, of, shareReplay, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public isFranchisee!: boolean;
  public franchiseeContractor_id!: string;
  public franchiseeProjectid!: string;
  public business!: string;
  private profile$: Observable<any> | null = null;

  constructor(private http: HttpClient) { }

  getProfileData() {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.GET_PROFILE;
    return this.http.get<any>(url, {});
  }
  private profileLoaded = false;
  loadProfileOnce(): Observable<any> {
    console.log(this.isFranchisee,'25========')
    console.log(this.franchiseeProjectid,'id franchise 26 common service----------')
    if (this.isFranchisee) {
      return of(null);
    }
    if (!this.profile$ && !this.isFranchisee) {
      this.profile$ = this.getProfileData().pipe(
        tap(res => {
          console.log('RAW PROFILE RESPONSE:', JSON.stringify(res, null, 2));

          this.isFranchisee = res?.data?.is_franchisee;
          this.franchiseeProjectid = res?.data?.franchisee_project_id;
          this.franchiseeContractor_id = res?.data?.franchisee_contractor_id;
          this.business = res?.data?.business;
          this.profileLoaded = true;
        }),
        shareReplay(1) // cache the result, replay to future subscribers
      );
    }
    return this.profile$;
  }


  updateProfile(data: any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.UPDATE_PROFILE;
    return this.http.post<any>(url, data);
  }

  getCountries() {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.GET_COUNTRY_LIST;
    return this.http.get<any>(url, {});
  }

  getSubCategory(params: any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.GET_SUB_CATEGORY;
    return this.http.get<any>(url, { params });
  }

  getCounties(params: any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.GET_SUB_CATEGORY;
    return this.http.get<any>(url, { params });
  }
}
